"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_FORMAT = exports.DEFAULT_EXPIRATION = exports.DEFAULT_CATALYST = exports.AUTH_METADATA_HEADER = exports.AUTH_TIMESTAMP_HEADER = exports.AUTH_CHAIN_HEADER_PREFIX = void 0;
exports.AUTH_CHAIN_HEADER_PREFIX = 'x-identity-auth-chain-';
exports.AUTH_TIMESTAMP_HEADER = 'x-identity-timestamp';
exports.AUTH_METADATA_HEADER = 'x-identity-metadata';
exports.DEFAULT_CATALYST = 'https://peer-lb.decentraland.org';
exports.DEFAULT_EXPIRATION = 1000 * 60 | 0;

var DEFAULT_ERROR_FORMAT = function DEFAULT_ERROR_FORMAT(err) {
  return {
    ok: false,
    message: err.message
  };
};

exports.DEFAULT_ERROR_FORMAT = DEFAULT_ERROR_FORMAT;